import type { RunStatus, StepState } from "@auradata/contracts";
import type { Status } from "@auradata/ui";

export const runStatus: Record<RunStatus, Status> = {
  queued: "neutral",
  running: "running",
  succeeded: "ok",
  warning: "warn",
  failed: "err",
  cancelled: "neutral",
};

export const runLabel: Record<RunStatus, string> = {
  queued: "Queued",
  running: "Running",
  succeeded: "Succeeded",
  warning: "Warning",
  failed: "Failed",
  cancelled: "Cancelled",
};

export const stepStatus: Record<StepState, Status> = {
  pass: "ok",
  fail: "err",
  run: "running",
  skip: "neutral",
  pending: "neutral",
  cancel: "neutral",
};
